import {
  GET_GENERAL_REPORT_FLAT,
  GET_GENERAL_REPORT_FLAT_ERROR,
  GET_GENERAL_REPORT_FLAT_SUCCESS,
} from './FlatTire.actions';

const flatReportState = {
  data: [],
  loading: true,
  error: undefined,
};

/**
 * The Flat Tire Reducer.
 */
const flatReportReducer = (state = flatReportState, { payload, type }) => {
  switch (type) {
    case GET_GENERAL_REPORT_FLAT: {
      return { ...state, loading: true, error: undefined };
    }
    case GET_GENERAL_REPORT_FLAT_ERROR: {
      return { ...state, loading: false, error: payload.error };
    }
    case GET_GENERAL_REPORT_FLAT_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: undefined,
        data: payload.data,
      };
    }
    default: {
      return state;
    }
  }
};

export default flatReportReducer;
